/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * 支付宝小程序新用户首页
 */
import { Component, InjectReactive, Mixins } from 'vue-property-decorator';
import type { Route } from 'vue-router/types/router';
import { session } from '@/shared/utils/storage';
import isPrerendering from '@/shared/utils/isPrerendering';
import AdvertDialog from '@/mixins/advert-dialog';

import { setIosBouncesEable } from '@/api/native';
import platform from '@/shared/utils/platform';
import { agreementService } from '@/service/confirm-agreements';
import type { Home } from '../../types';
import QualityContent from '../app-quality-home/quality-content';
import TaglessContent from './tagless-content';
import HomeWrapper from '../home-wrapper';
import Autarkey from '../../autarky';

const _isPrerendering = isPrerendering();
const style: Dictionary = require('./index.module.scss');

@Component
export default class AppTaglessHome extends Mixins(
  AdvertDialog,
  Autarkey,
) {
  @InjectReactive() homePage!: Home;

  private visibleQualityHomePage = true;

  private beforeRouteLeave(to: Route, from: Route, next: (d?: unknown) => void) {
    this.$ubtPageButton(
      'finance_taglessHome_outTime',
      'currentOutTime',
      `${new Date().getTime()}`,
    );

    // 离开页面时，设置ios可以弹性滚动
    setIosBouncesEable(true);

    /**
     * 如果需要对路由进行矫正，则不作做拦截；
     * 微信小程序无拦截退出挽留
     */
    if (this.homePage && this.homePage.shouldCorrectRouteByCredit()) {
      next();
    } else {
      this.controlPopVisible(to, from, next, platform.isWechatMini);
    }
  }

  private created() {
    if (!isPrerendering()) {
      if (this.homePage && this.homePage.shouldCorrectRouteByCredit()) {
        this.homePage.correctRouteByCredit();
      } else {
        agreementService.preloadAgreementsData();
      }

      // 设置ios弹性滚动禁止
      setIosBouncesEable(false);
    }
  }

  private mounted() {
    if (!_isPrerendering) {
      this.$ubtPageButton(
        'finance_taglessHome_inTime',
        'currentInTime',
        `${new Date().getTime()}`,
      );
    }
  }

  private render() {
    return (
      <HomeWrapper>
        <div class={[
          style.TaglessHome,
          this.visibleQualityHomePage && style.tagless,
        ]}>
          {!this.visibleQualityHomePage || this.isUpgradeSucceed ? (
            <QualityContent />
          ) : (
            <TaglessContent ontouchEnd={this.onHandleEnd.bind(this)} />
          )}
          {/* 主要用于命中用户返回的时候显示广告弹窗，见：popup.tsx */}
          {!_isPrerendering && this.renderAdvertDialog()}
        </div>
      </HomeWrapper>
    );
  }

  private onHandleEnd() {
    session.set('currentPage', this.$route.path);
    this.$ubtPageButton('finance_taglessHome_wipeUp');
    window.scrollTo(0, 1);
    this.visibleQualityHomePage = false;
  }
}
